export const PtwRoutePath = {
  Prefix: "ptw",
  Home: "/",

  // Authentication
  NotFoundError: "/404",
  InternalServerError: "/500",
  Login: "/login",
  ForgotPassword: "/forgot-password",

  // Dashboard
  Dashboard: "/dashboard",
  DashboardApprover: "/dashboard/approver",
  DashboardAuxPolice: "/dashboard/aux-police",

  //Profile
  Profile: "/profile",
  ProfileAccount: "/profileAccount",

  // Application Form
  Section1: "/new-permit/section1",
  Section1Edit: "/new-permit/section1Edit",
  Section2: "/new-permit/section2",
  Section3: "/new-permit/section3",
  Section4: "/new-permit/section4",
  Section5: "/new-permit/section5",

  // Draf Permit
  DraftPermit: "/draft-permit",
  DraftPermitDetails: "/draft-permit/details",
  DraftPermitSection2: "/draft-permit/section2",
  DraftPermitSection3: "/draft-permit/section3",
  DraftPermitSection4: "/draft-permit/section4",
  DraftPermitSection5: "/draft-permit/section5",

  // Pending Permit
  PendingPermit: "/pendingPermit",
  PendingPermitDetail: "/pendingPermit/:pendingId/details",
  PendingPermitId: (pendingId?: string) =>
    `/pendingPermit/${pendingId}/details`,

  // Active Permit
  ActivePermit: "/activePermit",
  ActivePermitSummary: "/activePermit/:activePermitId/summary",
  ActivePermitId: (activePermitId?: string) =>
    `/activePermit/${activePermitId}/summary`,
  ActivePermitDetails: "/activePermit/:activePermitId/details",
  ActivePermitIdDetails: (activePermitId?: string) =>
    `/activePermit/${activePermitId}/details`,
  ActivePermitSafetyForm: "/activePermit/:activePermitId/safetyform",
  ActivePermitIdSafetyForm: (activePermitId?: string) =>
    `/activePermit/${activePermitId}/safetyform`,
  ActivePermitPrint: "/activePermit/:activePermitId/printPermit",
  ActivePermitPrintId: (activePermitId?: string) =>
    `/activePermit/${activePermitId}/printPermit`,
  PublicPermitPrint: "/public/permit/print",

  // History User
  ApplicationHistory: "/applicationHistory",
  ApplicationHistorySummary:
    "/applicationHistory/:applicationHistoryId/summary",
  ApplicationHistoryId: (applicationHistoryId?: string) =>
    `/applicationHistory/${applicationHistoryId}/summary`,
  ApplicationHistoryDetails:
    "/applicationHistory/:applicationHistoryId/details",
  ApplicationHistoryIdDetails: (applicationHistoryId?: string) =>
    `/applicationHistory/${applicationHistoryId}/details`,
  ApplicationHistorySafetyForm:
    "/applicationHistory/:applicationHistoryId/safetyform",
  ApplicationHistoryIdSafetyForm: (applicationHistoryId?: string) =>
    `/applicationHistory/${applicationHistoryId}/safetyform`,
  ApplicationHistoryPrint:
    "/applicationHistory/:applicationHistoryId/printPermitHistory",
  ApplicationHistoryPrintId: (applicationHistoryId?: string) =>
    `/applicationHistory/${applicationHistoryId}/printPermitHistory`,

  PaymentHistory: "/paymentHistory",
  PaymentHistoryPrintReciept:
    "/paymentHistory/:paymentHistoryId/printReceiptPaymentHistory",
  PaymentHistoryPrintRecieptId: (paymentHistoryId?: string) =>
    `/paymentHistory/${paymentHistoryId}/printReceiptPaymentHistory`,

  // Payment Cart
  PaymentCart: "/paymentCart",
  PaymentCartDetails: "/paymentCart/details",
  PaymentSuccessCartSummary: "/paymentCart/summary/success",
  PaymentCartSummaryFailed: "/paymentCart/summary/failed",
  PaymentCartPrintReciept: "/paymentCart/print",

  // Manage
  AdminManagement: "/adminManagemant",
  PoManagement: "/projectOwnerManagement",
  AoManagement: "/areaOwnerManagement",
  HseManagement: "/hseManagement",
  ApManagement: "/auxPoliceManagement",
  TowManagement: "/towManagement",
  DowManagement: "/dowManagement",
  LocationManagement: "/locationManagement",
  DepartmentManagement: "/departmentManagement",

  // Auxiliary Police
  PendingPayment: "/pendingPayment",
  PendingPaymentDetails: "/pendingPayment/:pendingPaymentId/details",
  PendingPaymentIdDetails: (pendingPaymentId?: string) =>
    `/pendingPayment/${pendingPaymentId}/details`,
  PendingPaymentSummary: "/pendingPayment/summary",
  PendingPaymentFocSummary: "/pendingPayment/foc/summary",
  PendingPaymentPrintReciept: "/pendingPayment/print",

  HistoryPermitAp: "/historyPermit/ap",
  HistoryPermitSummaryAp: "/historyPermit/ap/:historyPermitId/summary",
  HistoryPermitIdAp: (historyPermitId?: string) =>
    `/historyPermit/ap/${historyPermitId}/summary`,
  HistoryPermitDetailsAp: "/historyPermit/ap/:historyPermitId/details",
  HistoryPermitIdDetailsAp: (historyPermitId?: string) =>
    `/historyPermit/ap/${historyPermitId}/details`,
  HistoryPermitPrintAp: "/historyPermit/ap/:historyPermitId/print",
  HistoryPermitPrintIdAp: (historyPermitId?: string) =>
    `/historyPermit/ap/${historyPermitId}/print`,

  HistoryPayment: "/historyPayment",
  HistoryPaymentReport: "/historyPayment/report",
  HistoryPaymentSummaryAp: "/historyPayment/ap/:historyPaymentId/summary",
  HistoryPaymentIdAp: (historyPaymentId?: string) =>
    `/historyPayment/ap/${historyPaymentId}/summary`,
  HistoryPaymentPrintReciept: "/historyPayment/print",
  HistoryPaymentDeletedReceipt: "/historyPayment/deletedReceipt",

  // Approver
  SuspendForm: "/suspendForm",
  ListApplication: "/suspendForm/listofApplication",

  UnsuspendForm: "/unsuspendForm",
  UnsuspendListApplication: "/unsuspendForm/listofApplication",

  ListApplicationSummary: "/suspendForm/listofApplication/summary",
  UnsuspendListApplicationSummary: "/unsuspendForm/listofApplication/summary",

  // Pending Approval PO, AO, HSE
  NewPermit: "/newPermit",
  NewPermitSummary: "/newPermit/:newPermitId/summary",
  NewPermitId: (newPermitId?: string) => `/newPermit/${newPermitId}/summary`,

  Extend: "/extendPermit",
  ExtendDetails: "/extendPermit/:extendPermitId/details",
  ExtendPermitSummary: "/extendPermit/:extendPermitId/summary",
  ExtendPermitId: (extendPermitId?: string) =>
    `/extendPermit/${extendPermitId}/summary`,
  ExtendByIdDetails: (extendPermitId?: string) =>
    `/extendPermit/${extendPermitId}/details`,

  CloseDaily: "/closeDaily",
  CloseDailyDetails: "/closeDaily/:closeDailyId/details",
  CloseDailySummary: "/closeDaily/:closeDailyId/summary",
  CloseDailyId: (closeDailyId?: string) =>
    `/closeDaily/${closeDailyId}/summary`,
  CloseDailyByIdDetails: (closeDailyId?: string) =>
    `/closeDaily/${closeDailyId}/details`,

  // Approver Active Permit
  ActivePermitApprover: "/approver/activePermit",
  ActivePermitApproverSummary: "/approver/activePermit/:activePermitId/summary",
  ActivePermitApproverId: (activePermitId?: string) =>
    `/approver/activePermit/${activePermitId}/summary`,
  ActivePermitApproverDetails: "/approver/activePermit/:activePermitId/details",
  ActivePermitApproverIdDetails: (activePermitId?: string) =>
    `/approver/activePermit/${activePermitId}/details`,
  ActivePermitApproverPrint:
    "/approver/activePermit/:activePermitId/printPermit",
  ActivePermitApproverPrintId: (activePermitId?: string) =>
    `/approver/activePermit/${activePermitId}/printPermit`,
  ActivePermitApproverSafetyForm: "/approver/activePermit//safetyform",

  Closing: "/closing",
  ClosingReportRegister: "/closing/:closingId/report/register",
  ClosingReportRegisterId: (closingId?: string) =>
    `/closing/${closingId}/report/register`,
  ClosingDetails: "/closing/:closingId/details",
  ClosingByIdDetails: (closingId?: string) => `/closing/${closingId}/details`,
  ClosingSummary: "/closing/:closingId/summary",
  ClosingId: (closingId?: string) => `/closing/${closingId}/summary`,
  CompletePermit: "/completePermit",
  CompletePermitDetails: "/completePermit/:completePermitId/details",
  CompletePermitIdDetails: (completePermitId?: string) =>
    `/completePermit/${completePermitId}/details`,
  CompletePermitSummary: "/completePermit/:completePermitId/summary",
  CompletePermitId: (completePermitId?: string) =>
    `/completePermit/${completePermitId}/summary`,

  HistoryPermit: "/historyPermit",
  HistoryPermitSummary: "/historyPermit/:historyPermitId/summary",
  HistoryPermitId: (historyPermitId?: string) =>
    `/historyPermit/${historyPermitId}/summary`,
  HistoryPermitDetails: "/historyPermit/:historyPermitId/details",
  HistoryPermitIdDetails: (historyPermitId?: string) =>
    `/historyPermit/${historyPermitId}/details`,
  HistoryPermitSafetyForm: "/historyPermit/:historyPermitId/safetyform",
  HistoryPermitIdSafetyForm: (historyPermitId?: string) =>
    `/historyPermit/${historyPermitId}/safetyform`,
  HistoryPermitPrint: "/historyPermit/:historyPermitId/print",
  HistoryPermitPrintId: (historyPermitId?: string) =>
    `/historyPermit/${historyPermitId}/print`,
  HistoryPermitPrintListPreview:
    "/historyPermit/:historyPermitId/print/listpreview",
  HistoryPermitPrintListPreviewId: (historyPermitId?: string) =>
    `/historyPermit/${historyPermitId}/print/listpreview`,

  //Safety Breifing Holder
  SafetyBriefing: "/approver/safetyBriefing",
};
